export default __webpack_public_path__ + "static/media/cancel-icon-active.b7fc4261.svg";